import deepmerge from "@node/deepmerge"

let locales = {}
const modules = import.meta.glob("@o-din-pm/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-pm/src/pm/store";
import menu from "@o-din-pm/src/pm/menu.json";

export default {
  routes: [
    { path: "/pm/dashboards", component: () => import("./views/pm/dashboard/Index.vue") },
    { path: "/pm/offers", component: () => import("./views/pm/offers/Index.vue") },
    { path: "/pm/offers/new", component: () => import("./views/pm/offers/Form.vue") },
    { path: "/pm/offers/:id/edit", component: () => import("./views/pm/offers/Form.vue") },
    { path: "/pm/contracts", component: () => import("./views/pm/contracts/Index.vue") },
    { path: "/pm/contracts/new", component: () => import("./views/pm/contracts/Form.vue") },
    { path: "/pm/contracts/:id/edit", component: () => import("./views/pm/contracts/Form.vue") },
    { path: "/pm/contracts/:id", component: () => import("./views/pm/contracts/Show.vue") },
    { path: "/pm/expenses/:id/edit", component: () => import("./views/pm/expenses/Form.vue") },
    { path: "/pm/expenses/new", component: () => import("./views/pm/expenses/Form.vue") },
    { path: "/pm/expenses", component: () => import("./views/pm/expenses/Index.vue") },
    { path: "/pm/expenses/:id", component: () => import("./views/pm/expenses/Show.vue") },
    { path: "/pm/payments", component: () => import("./views/pm/payments/Index.vue") },
    { path: "/pm/payments/new", component: () => import("./views/pm/payments/Form.vue") },
    { path: "/pm/payments/:id/edit", component: () => import("./views/pm/payments/Form.vue") },
    { path: "/pm/payment_purposes", component: () => import("./views/pm/payment_purposes/Index.vue") },
    { path: "/pm/payment_purposes/:id", component: () => import("./views/pm/payment_purposes/Show.vue") },
    { path: "/pm/payment_purposes/:id/edit", component: () => import("./views/pm/payment_purposes/Update.vue") },
    { path: "/pm/payment_types", component: () => import("./views/pm/payment_types/Index.vue") },
    { path: "/pm/payment_types/new", component: () => import("./views/pm/payment_types/Form.vue") },
    { path: "/pm/payment_types/:id/edit", component: () => import("./views/pm/payment_types/Form.vue") },
    { path: "/pm/currencies", component: () => import("./views/pm/currencies/Index.vue") },
    { path: "/pm/currencies/:id/edit", component: () => import("./views/pm/currencies/Form.vue") },
    { path: "/pm/currencies/new", component: () => import("./views/pm/currencies/Form.vue") },
    { path: "/pm/templates", component: () => import("./views/pm/templates/Index.vue") },
    { path: "/pm/templates/:id/edit", component: () => import("./views/pm/templates/Form.vue") },
    { path: "/pm/templates/new", component: () => import("./views/pm/templates/Form.vue") },

  ],
  locales,
  store,
  menu: [menu]
}
